import { useSplitTreatments } from "@splitsoftware/splitio-react";
import { useCookies } from "react-cookie";

export const flags = {
  CLARITY_ADMIN_LEGACY_USER_MANAGEMENT: "clarity-admin-legacy-user-management",
  MANAGE_ORGANISATIONS_WITH_IDEM: "manage-organisations-with-idem",
  CLARITY_ADMIN_QUERY_ENGINE_CONFIG: "clarity-admin-query-engine-config",
};

/**
 * @returns {boolean} true if feature is enabled, false otherwise
 * @param featureName
 */
export const useIsFeatureEnabled = (featureName) => {
  const [cookie] = useCookies(["clarityFlagOverrides"]);
  const featureFlagData = useSplitTreatments({ names: [featureName] });

  if (cookie.clarityFlagOverrides) {
    if (cookie.clarityFlagOverrides[featureName] === true) return true;
    if (cookie.clarityFlagOverrides[featureName] === false) return false;
  }

  return featureFlagData?.treatments?.[featureName]?.treatment === "on";
};
